module.exports = __webpack_public_path__ + "static/media/vassen.3ab6a57a.m4a";